import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { designTokens } from "theme";

// height of the dashboard layout's sticky top nav, so the bar pins directly beneath it
const TOP_NAV_HEIGHT = 100;

export const styles = (theme: Theme) => {
	const border = `1px solid ${theme.palette.custom.divider}`;
	return {
		bar: {
			position: "sticky",
			top: TOP_NAV_HEIGHT,
			zIndex: theme.zIndex.appBar - 1,
			display: "flex",
			flexWrap: "wrap",
			justifyContent: "space-between",
			alignItems: "center",
			gap: theme.spacing(1),
			margin: "-16px -32px 16px",
			padding: theme.spacing(1.5, 4),
			backgroundColor: designTokens.colors.grayLight,
			borderBottom: border,
		},
		backLink: {
			display: "inline-flex",
			alignItems: "center",
			gap: theme.spacing(0.75),
			fontSize: 14,
			fontWeight: 500,
			textDecoration: "none",
		},
		icon: {
			width: 16,
			height: 16,
		},
		controls: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1.5),
		},
		filterButton: {
			height: 36,
			boxSizing: "border-box",
			minWidth: 0,
			backgroundColor: "white",
			borderColor: theme.palette.custom.divider,
			fontWeight: 600,
			"&:hover": {
				backgroundColor: "white",
			},
		},
		pager: {
			display: "flex",
			alignItems: "stretch",
			height: 36,
			boxSizing: "border-box",
			border,
			borderRadius: 4,
			backgroundColor: "white",
			overflow: "hidden",
		},
		pagerButton: {
			borderRadius: 0,
			padding: theme.spacing(0, 1.5),
			fontWeight: 600,
			whiteSpace: "nowrap",
		},
		position: {
			display: "flex",
			alignItems: "center",
			padding: theme.spacing(0, 2),
			borderLeft: border,
			borderRight: border,
			fontSize: 14,
			fontWeight: 700,
			whiteSpace: "nowrap",
		},
		summary: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1.5),
			padding: theme.spacing(2),
			maxWidth: 420,
		},
		summaryRow: {
			display: "flex",
			alignItems: "flex-start",
			gap: theme.spacing(2),
		},
		summaryLabel: {
			flexShrink: 0,
			width: 60,
			color: theme.palette.text.secondary,
		},
		chips: {
			display: "flex",
			flexWrap: "wrap",
			gap: theme.spacing(0.5),
			"& .MuiChip-root": {
				margin: 0,
			},
		},
		summaryLink: {
			alignSelf: "flex-start",
			fontSize: "inherit",
		},
	} satisfies Record<string, CSSObject>;
};
